module.exports = __webpack_public_path__ + "static/img/03guandeng.cad9d148.gif";